import { render, staticRenderFns } from "./IsChildren.vue?vue&type=template&id=7920be4d&scoped=true&"
var script = {}
import style0 from "./IsChildren.vue?vue&type=style&index=0&id=7920be4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7920be4d",
  null
  
)

export default component.exports